import categoriesJson from "@/data/blog/lib/categories.json";

import type { BlogCategory } from "@/lib/blog-cards";

const blogCategories = categoriesJson as BlogCategory[];

function readCategorySlug(category: BlogCategory): string | undefined {
  const slug = category.slug;
  if (typeof slug === "string") {
    const trimmed = slug.trim();
    return trimmed.length > 0 ? trimmed : undefined;
  }
  return undefined;
}

/** Stable URL slug for a category Mongo `_id`. */
export function getBlogCategorySlugById(categoryId: string): string | undefined {
  const hit = blogCategories.find((category) => category._id === categoryId);
  return hit ? readCategorySlug(hit) : undefined;
}

/**
 * Maps `?category=` query value (slug or legacy `_id`) to a category `_id` for filtering.
 * Unknown values are ignored (returns undefined).
 */
export function resolveBlogCategoryIdFromParam(
  raw: string | undefined,
): string | undefined {
  const param = raw?.trim();
  if (!param) return undefined;

  const bySlug = blogCategories.find((category) => readCategorySlug(category) === param);
  if (bySlug) return bySlug._id;

  const byId = blogCategories.find((category) => category._id === param);
  if (byId) return byId._id;

  return undefined;
}

/** Canonical slug for hrefs; accepts slug or legacy `_id` in the current query value. */
export function resolveBlogCategorySlugForHref(
  raw: string | undefined,
): string | undefined {
  const categoryId = resolveBlogCategoryIdFromParam(raw);
  if (!categoryId) return undefined;
  return getBlogCategorySlugById(categoryId);
}
